export const GET_NA_COURT_CONFIG_DATA = 'GET_NA_COURT_CONFIG_DATA';
export const GET_NA_COURT_CONFIG_DATA_SUCCESS = 'GET_NA_COURT_CONFIG_DATA_SUCCESS';
export const GET_NA_COURT_CONFIG_DATA_FAILURE = 'GET_NA_COURT_CONFIG_DATA_FAILURE';
export const GET_NA_DEFAULT_COURT_CONFIG_DATA = 'GET_NA_DEFAULT_COURT_CONFIG_DATA';
export const GET_NA_DEFAULT_COURT_CONFIG_DATA_SUCCESS = 'GET_NA_DEFAULT_COURT_CONFIG_DATA_SUCCESS';
export const GET_NA_DEFAULT_COURT_CONFIG_DATA_FAILURE = 'GET_NA_DEFAULT_COURT_CONFIG_DATA_FAILURE';
export const SAVE_NA_COURT_CONFIG_DATA = 'SAVE_NA_COURT_CONFIG_DATA';
export const SAVE_NA_COURT_CONFIG_DATA_SUCCESS = 'SAVE_NA_COURT_CONFIG_DATA_SUCCESS';
export const SAVE_NA_COURT_CONFIG_DATA_FAILURE = 'SAVE_NA_COURT_CONFIG_DATA_FAILURE';
export const UPDATE_NA_FACILITIES_BASED_ON_CONFIG = 'UPDATE_NA_FACILITIES_BASED_ON_CONFIG';
export const UPDATE_NA_SELECTED_FACILITY = 'UPDATE_NA_SELECTED_FACILITY';
export const UPDATE_NA_SHOW_CONFIG_MODAL = 'UPDATE_NA_SHOW_CONFIG_MODAL';
export const UPDATE_NA_SIDE_BAR_DISPLAY_TYPE = 'UPDATE_NA_SIDE_BAR_DISPLAY_TYPE';
export const UPDATE_NA_SIDE_BAR_STATUS_TYPE = 'UPDATE_NA_SIDE_BAR_STATUS_TYPE';
export const CLEAR_NEXT_AVAILABLE_DATA = 'CLEAR_NEXT_AVAILABLE_DATA';
export const TOGGLE_NA_ADD_DRAWS_SIDE_PANEL = 'TOGGLE_NA_ADD_DRAWS_SIDE_PANEL';
export const SAVE_NA_DRAWS_TO_SCHEDULE = 'SAVE_NA_DRAWS_TO_SCHEDULE';
export const SAVE_NA_DRAWS_TO_SCHEDULE_SUCCESS = 'SAVE_NA_DRAWS_TO_SCHEDULE_SUCCESS';
export const SAVE_NA_DRAWS_TO_SCHEDULE_FAILURE = 'SAVE_NA_DRAWS_TO_SCHEDULE_FAILURE';
export const GET_NA_DRAWS_SCHEDULED = 'GET_NA_DRAWS_SCHEDULED';
export const GET_NA_DRAWS_SCHEDULED_SUCCESS = 'GET_NA_DRAWS_SCHEDULED_SUCCESS';
export const GET_NA_DRAWS_SCHEDULED_FAILURE = 'GET_NA_DRAWS_SCHEDULED_FAILURE';
export const CLEAR_NA_DRAWS_NOTIFICATIONS = 'CLEAR_NA_DRAWS_NOTIFICATIONS';
export const UPDATE_NA_NOT_ON_COURT_MATCHES = 'UPDATE_NA_NOT_ON_COURT_MATCHES';
export const UPDATE_NA_ON_COURT_MATCHES = 'UPDATE_NA_ON_COURT_MATCHES';
export const GET_NA_NOT_ON_COURT_MATCHES = 'GET_NA_NOT_ON_COURT_MATCHES';
export const GET_NA_NOT_ON_COURT_MATCHES_SUCCESS = 'GET_NA_NOT_ON_COURT_MATCHES_SUCCESS';
export const GET_NA_NOT_ON_COURT_MATCHES_FAILURE = 'GET_NA_NOT_ON_COURT_MATCHES_FAILURE';
export const GET_NA_ON_COURT_MATCHES = 'GET_NA_ON_COURT_MATCHES';
export const GET_NA_ON_COURT_MATCHES_SUCCESS = 'GET_NA_ON_COURT_MATCHES_SUCCESS';
export const GET_NA_ON_COURT_MATCHES_FAILURE = 'GET_NA_ON_COURT_MATCHES_FAILURE';
export const UPDATE_NA_SUMMARY = 'UPDATE_NA_SUMMARY';
export const CLEAR_NA_CONFIG_AND_FACILITY_SPECIFIC_DATA = 'CLEAR_NA_CONFIG_AND_FACILITY_SPECIFIC_DATA';
export const SHOW_MATCH_STARTED_MODAL = 'SHOW_MATCH_STARTED_MODAL';
export const NA_POST_SCORE = 'NA_POST_SCORE';
export const NA_POST_SCORE_SUCCESS = 'NA_POST_SCORE_SUCCESS';
export const NA_POST_SCORE_FAILURE = 'NA_POST_SCORE_FAILURE';
export const NA_POST_SCORE_CLEAR = 'NA_POST_SCORE_CLEAR';
export const SET_NA_ACTION_CONFIRM_POPUP_DATA = 'SET_NA_ACTION_CONFIRM_POPUP_DATA';
export const NA_PUBLISH_DRAWS = 'NA_PUBLISH_DRAWS';
export const NA_PUBLISH_DRAWS_SUCCESS = 'NA_PUBLISH_DRAWS_SUCCESS';
export const NA_PUBLISH_DRAWS_FAILURE = 'NA_PUBLISH_DRAWS_FAILURE';
export const NA_CLEAR_PUBLISH_STATUS = 'NA_CLEAR_PUBLISH_STATUS';
